(function () {
  var TRANSIT = { FR: [3, 5], BE: [3, 6], LU: [3, 6], NL: [3, 6], DE: [5, 8], GB: [3, 5], CA: [5, 7], US: [5, 8], AU: [4, 7], SG: [6, 7], NZ: [6, 10], IE: [6, 10], MY: [8, 10], PT: [5, 8] };
  var SHIP_TEXT = {
    fr: { FR: 'Livraison Express offerte en France', BE: 'Livraison Express offerte en Belgique', NL: 'Livraison Express offerte aux Pays-Bas', DE: 'Livraison Express offerte en Allemagne' },
    de: { FR: 'Kostenloser Express-Versand nach Frankreich', BE: 'Kostenloser Express-Versand nach Belgien', NL: 'Kostenloser Express-Versand in die Niederlande', DE: 'Kostenloser Express-Versand nach Deutschland' },
    nl: { FR: 'Gratis expreslevering naar Frankrijk', BE: 'Gratis expreslevering naar België', NL: 'Gratis expreslevering naar Nederland', DE: 'Gratis expreslevering naar Duitsland' },
    en: { FR: 'Free Express shipping to France', BE: 'Free Express shipping to Belgium', NL: 'Free Express shipping to the Netherlands', DE: 'Free Express shipping to Germany' }
  };
  var WORLD_TEXT = { fr: 'Livraison Express offerte dans le monde entier', de: 'Kostenloser Express-Versand weltweit', nl: 'Gratis expreslevering wereldwijd', en: 'Free Express shipping worldwide' };
  var GLOBE_ICON = '<svg class="pp-ship-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3c2.5 2.5 3.8 5.7 3.8 9s-1.3 6.5-3.8 9c-2.5-2.5-3.8-5.7-3.8-9S9.5 5.5 12 3z"/></svg>';
  function pageLang() { return (document.documentElement.lang || 'en').slice(0, 2).toLowerCase(); }
  function injectCSS() {
    if (document.getElementById('pp-ship-eta-css')) return;
    var s = document.createElement('style');
    s.id = 'pp-ship-eta-css';
    s.textContent = '.pp-ship-eta-stack{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;gap:8px;}.pp-ship-eta-stack .pp-flag{transition:transform .25s ease;}.pp-ship-eta-stack .pp-flag:hover{transform:scale(1.2);}.pp-ship-eta-stack .pp-ship-globe{display:inline-flex;}.pp-ship-eta-stack .pp-ship-ic{width:18px;height:18px;opacity:.85;}.pp-ship-eta-stack .pp-ship-line{display:flex;flex-wrap:wrap;align-items:baseline;gap:6px;}';
    (document.head || document.documentElement).appendChild(s);
  }
  function init() {
    var el = document.querySelector('.pp-ship');
    if (!el || el.getAttribute('data-eta-fixed') === '1') return;
    var img = el.querySelector('.pp-flag');
    if (!img) return;
    var re = new RegExp('flagcdn.com/([a-z]{2}).svg');
    var m = (img.getAttribute('src') || '').match(re);
    var country = m ? m[1].toUpperCase() : '';
    var range = TRANSIT[country];

    injectCSS();
    el.classList.add('pp-ship-eta-stack');

    var mainText = '';
    Array.prototype.slice.call(el.childNodes).forEach(function (node) {
      if (node === img) return;
      if (node.nodeType === 3) {
        mainText += node.textContent;
        el.removeChild(node);
      }
    });
    mainText = mainText.trim();

    var line = document.createElement('span');
    line.className = 'pp-ship-line';
    var mainSpan = document.createElement('span');
    mainSpan.className = 'pp-ship-main';

    if (range) {
      var l = pageLang();
      var override = SHIP_TEXT[l] && SHIP_TEXT[l][country];
      mainSpan.textContent = override || mainText;
    } else {
      var globe = document.createElement('span');
      globe.className = 'pp-ship-globe';
      globe.innerHTML = GLOBE_ICON;
      img.parentNode.replaceChild(globe, img);
      mainSpan.textContent = WORLD_TEXT[pageLang()] || WORLD_TEXT.en;
    }

    line.appendChild(mainSpan);
    el.appendChild(line);
    el.setAttribute('data-eta-fixed', '1');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
